<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {
    let arr = window.location.hash.split('/')
    let newArr = []
    if ((window.location.hash === '#/m' || window.location.hash.indexOf('#/mett') > -1 || window.location.hash === '#/mlogin' || window.location.hash.indexOf('#/mregister') > -1) && (!this.isMobile().versions.mobile && !this.isMobile().versions.android && !this.isMobile().versions.ios && !this.isHandIOS())) {
      arr.forEach((it, index) => {
        if (index !== 0) {
          it = index == 1 ? it.substr(1) : it
          newArr.push(it)
        }
      })
      this.$router.replace('/' + newArr.join('/'));
    }
    if ((window.location.hash === '#/' || window.location.hash.indexOf('#/ett') > -1 || window.location.hash === '#/login' || window.location.hash.indexOf('#/register') > -1) && (this.isMobile().versions.mobile || this.isMobile().versions.android || this.isMobile().versions.ios || this.isHandIOS())) {
      arr.forEach((it, index) => {
        if (index !== 0) {
          it = index == 1 ? 'm' + it : it
          newArr.push(it)
        }
      })
      this.$router.replace('/' + newArr.join('/'));
    }
  },
  methods: {
    isMobile() {
      let u = navigator.userAgent
      let app = navigator.appVersion
      let browser = {
        versions: {
          mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
          android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
        },
        language: (navigator.browserLanguage || navigator.language).toLowerCase() //检测浏览器语言
      }
      return browser
    },
    isHandIOS() {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
    }
  }
}
</script>